import React from 'react';
import { isCondensedLayout } from '@/constants/workflow-editor';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';
import { MessageCircleWarning } from 'lucide-react';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';
import { useCannyIdentify } from '@/hooks/use-canny-identify';
// TODO: Implement Canny Feedback Widget when it's ready

interface UtilityPanelProps {
  panelGroupWidth?: number;
}

export const UtilityPanel: React.FC<UtilityPanelProps> = ({
  panelGroupWidth,
}) => {
  const isCondensed = isCondensedLayout(panelGroupWidth);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const { isFeedbackEnabled } = useLaunchDarkly();
  const cannyAppId = import.meta.env.VITE_CANNY_APP_ID;
  const cannyUrl = import.meta.env.VITE_CANNY_URL;

  useCannyIdentify(isFeedbackEnabled);

  const isConfigured = cannyAppId && cannyUrl;

  if (!isFeedbackEnabled) {
    return null;
  }

  return (
    <>
      <div className='flex items-center gap-2 rounded-lg p-1.5 h-12 shadow-lg border border-border bg-card'>
        <Tooltip>
          <TooltipTrigger asChild>
            <a
              data-canny-link
              href={isConfigured ? cannyUrl : '#'}
              className='inline-flex items-center gap-2 p-2 hover:bg-muted transition-colors rounded-md text-sm font-medium text-gray-700 dark:text-white'
              onClick={(e) => {
                if (!isConfigured) {
                  e.preventDefault();
                }
              }}
              target='_blank'
              rel='noopener noreferrer'
            >
              <MessageCircleWarning className='size-5 text-foreground' />
              {!isCondensed && <span>Submit Feedback</span>}
            </a>
          </TooltipTrigger>
          <TooltipContent side='bottom'>
            <p>Feedback: Share your thoughts and report issues</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </>
  );
};
